import { cn } from "./ui/utils";
import { Chat } from "./chat";
import { useUI } from "./context/ui";
import { Avatar } from "@exact-magic/ui";
import { useChat } from "./context/use-chat";

interface LauncherIconProps {
  children: React.ReactNode;
  active: boolean;
  rotation: number;
}

const LauncherIcon = ({ children, active, rotation }: LauncherIconProps) => {
  return (
    <div
      className={cn(
        "absolute inset-y-0 flex w-full select-none items-center justify-center transition-all",
        active ? "scale-100 opacity-100" : "scale-0 opacity-0",
      )}
      style={{ rotate: active ? "0deg" : `${rotation}deg` }}
    >
      {children}
    </div>
  );
};

const Launcher = () => {
  const { ui, toggle } = useUI();
  const {
    assistant: { avatar, name },
  } = useChat();

  return (
    <div
      className="flex flex-none origin-center scale-100 cursor-pointer items-center justify-center overflow-hidden rounded-full bg-cc primary transition-transform duration-200 hover:scale-110 active:scale-90 size-14"
      onClick={toggle}
    >
      <LauncherIcon active={!ui.open} rotation={30}>
        <Avatar src={avatar} name={name} size="2xl" />
      </LauncherIcon>
      <LauncherIcon active={ui.open} rotation={-60}>
        <svg width="32" height="32" fill="white" viewBox="0 0 24 24">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
          ></path>
        </svg>
      </LauncherIcon>
    </div>
  );
};

interface ContentProps {
  children: React.ReactNode;
}

const Content = ({ children }: ContentProps) => {
  const { ui } = useUI();
  return (
    <div
      className={cn(
        "absolute inset-0 flex min-h-20 origin-bottom-right flex-col overflow-hidden bg-white shadow transition-all duration-200 flex-1 h-full w-full z-10 rounded-2xl @md:relative",
        {
          "pointer-events-all opacity-1 scale-100": ui.open,
          "pointer-events-none opacity-0 scale-0": !ui.open,
        },
      )}
    >
      {children}
    </div>
  );
};

export const Component = () => {
  return (
    <div className="@container absolute bottom-0 right-0 inset-0">
      <div className="w-full h-full flex flex-col items-end justify-end gap-4 p-5">
        <Content>
          <Chat />
        </Content>
        <Launcher />
      </div>
    </div>
  );
};